import { FilterPreset } from './types';

export enum PresetLocations {
  MIAMI = 'miami, fl',
  CHICAGO = 'chicago, il',
  LAKE_TAHOE = 'lake tahoe',
  SEATTLE = 'seattle, wa',
  LAKE_TRAVIS = 'lake travis, tx',
  FORT_LAUDERDALE = 'fort lauderdale, fl',
  TAMPA = 'tampa, fl',
  LOS_ANGELES = 'los angeles, ca',
  NEW_YORK = 'new york, ny',
  LAKE_NORMAN = 'lake norman, nc',
  LAKE_AUSTIN = 'lake austin, tx',
}

type LocationPresets = {
  [key in PresetLocations]: FilterPreset[];
};

export const LOCATION_FILTER_PRESETS: LocationPresets = {
  [PresetLocations.MIAMI]: [
    {
      id: 'miami-yachts',
      label: 'Yachts',
      filters: {
        captainOption: 'captain',
        boatCategories: ['mega_yacht', 'motor_yacht'],
        lengthRange: [45, 65],
      },
    },
    {
      id: 'miami-under-250',
      label: 'Under $250/hour',
      filters: {
        priceRange: [0, 250],
      },
    },
    {
      id: 'miami-sandbars',
      label: 'Miami Sandbars',
      filters: {
        captainOption: 'captain',
        lengthRange: [35, 50],
        boatCategories: ['power'],
        amenities: ['bathroom'],
      },
    },
  ],

  [PresetLocations.CHICAGO]: [
    {
      id: 'chicago-yachts',
      label: 'Yachts',
      filters: {
        captainOption: 'captain',
        boatCategories: ['mega_yacht', 'motor_yacht'],
        lengthRange: [40],
      },
    },
    {
      id: 'chicago-under-300',
      label: 'Under $300/hour',
      filters: {
        priceRange: [0, 300],
      },
    },
    {
      id: 'chicago-playpen-party',
      label: 'Playpen Party',
      filters: {
        captainOption: 'captain',
        lengthRange: [35, 50],
        boatCategories: ['power'],
        amenities: ['bathroom'],
      },
    },
  ],

  [PresetLocations.LAKE_TAHOE]: [
    {
      id: 'tahoe-deck-boats',
      label: 'Deck Boats',
      filters: {
        boatCategories: ['deck_boat', 'bow_rider'],
      },
    },
    {
      id: 'tahoe-under-250',
      label: 'Under $250/hour',
      filters: {
        priceRange: [0, 250],
      },
    },
    {
      id: 'tahoe-watersports',
      label: 'Watersports',
      filters: {
        activities: ['watersports'],
      },
    },
  ],

  [PresetLocations.SEATTLE]: [
    {
      id: 'seattle-pontoon-boats',
      label: 'Pontoon Boats',
      filters: {
        boatCategories: ['pontoon'],
      },
    },
    {
      id: 'seattle-under-150',
      label: 'Under $150/hour',
      filters: {
        priceRange: [0, 150],
      },
    },
    {
      id: 'seattle-watersports',
      label: 'Watersports',
      filters: {
        activities: ['watersports'],
      },
    },
  ],

  [PresetLocations.LAKE_TRAVIS]: [
    {
      id: 'lake-travis-pontoon-boats',
      label: 'Pontoon Boats',
      filters: {
        boatCategories: ['pontoon'],
      },
    },
    {
      id: 'lake-travis-under-150',
      label: 'Under $150/hour',
      filters: {
        priceRange: [0, 150],
      },
    },
    {
      id: 'lake-travis-watersports',
      label: 'Watersports',
      filters: {
        activities: ['watersports'],
      },
    },
  ],
  [PresetLocations.FORT_LAUDERDALE]: [
    {
      id: 'fort-lauderdale-pontoon-boats',
      label: 'Pontoon Boats',
      filters: {
        boatCategories: ['pontoon'],
      },
    },
    {
      id: 'fort-lauderdale-under-200',
      label: 'Under $200/hour',
      filters: {
        priceRange: [0, 200],
      },
    },
    {
      id: 'las-olas-cruising',
      label: 'Las Olas Cruising',
      filters: {
        captainOption: 'captain',
        lengthRange: [35, 50],
        boatCategories: ['power'],
        amenities: ['bathroom'],
      },
    },
  ],
  [PresetLocations.TAMPA]: [
    {
      id: 'tampa-pontoon-boats',
      label: 'Pontoon Boats',
      filters: {
        boatCategories: ['pontoon'],
      },
    },
    {
      id: 'tampa-under-150',
      label: 'Under $150/hour',
      filters: {
        priceRange: [0, 150],
      },
    },
    {
      id: 'tampa-bay-cruising',
      label: 'Tampa Bay Cruising',
      filters: {
        captainOption: 'captain',
        lengthRange: [35, 50],
        boatCategories: ['power'],
        amenities: ['bathroom'],
      },
    },
  ],
  [PresetLocations.LOS_ANGELES]: [
    {
      id: 'los-angeles-yachts',
      label: 'Yachts',
      filters: {
        captainOption: 'captain',
        boatCategories: ['mega_yacht', 'motor_yacht'],
        lengthRange: [40],
      },
    },
    {
      id: 'los-angeles-under-300',
      label: 'Under $300/hour',
      filters: {
        priceRange: [0, 300],
      },
    },
    {
      id: 'los-angeles-sailing',
      label: 'Sailing',
      filters: {
        activities: ['sailing'],
      },
    },
  ],
  [PresetLocations.NEW_YORK]: [
    {
      id: 'new-york-yachts',
      label: 'Yachts',
      filters: {
        boatCategories: ['mega_yacht', 'motor_yacht'],
        lengthRange: [0, 65],
      },
    },
    {
      id: 'new-york-under-300',
      label: 'Under $300/hour',
      filters: {
        priceRange: [0, 300],
      },
    },
    {
      id: 'new-york-sailing',
      label: 'Sailing',
      filters: {
        activities: ['sailing'],
      },
    },
  ],
  [PresetLocations.LAKE_NORMAN]: [
    {
      id: 'lake-norman-pontoon-boats',
      label: 'Pontoon Boats',
      filters: {
        boatCategories: ['pontoon'],
      },
    },
    {
      id: 'lake-norman-under-150',
      label: 'Under $150/hour',
      filters: {
        priceRange: [0, 150],
      },
    },
    {
      id: 'lake-norman-lakeside-cruising',
      label: 'Lakeside Cruising',
      filters: {
        captainOption: 'captain',

        lengthRange: [25],
        passengers: 6,
      },
    },
  ],
  [PresetLocations.LAKE_AUSTIN]: [
    {
      id: 'austin-pontoon-boats',
      label: 'Pontoon Boats',
      filters: {
        boatCategories: ['pontoon'],
      },
    },
    {
      id: 'austin-under-150',
      label: 'Under $150/hour',
      filters: {
        priceRange: [0, 150],
      },
    },
    {
      id: 'austin-watersports',
      label: 'Watersports',
      filters: {
        activities: ['watersports'],
      },
    },
  ],
};

// Global presets that apply to all locations (optional)
export const GLOBAL_FILTER_PRESETS: FilterPreset[] = [
  {
    id: 'available-this-weekend',
    label: 'Available This Weekend!',
    filters: {
      instantBook: true,
      weekendAvailable: true,
    },
  },
];
